import { render, staticRenderFns } from "./TasanteaProductDetail.vue?vue&type=template&id=afc0d6a4&scoped=true"
import script from "./TasanteaProductDetail.vue?vue&type=script&lang=js"
export * from "./TasanteaProductDetail.vue?vue&type=script&lang=js"
import style0 from "./TasanteaProductDetail.vue?vue&type=style&index=0&id=afc0d6a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc0d6a4",
  null
  
)

export default component.exports